import React, { useState } from 'react';

import FundingNewsMentions from './FundingNewsMentions';
import FundingInvestors from './FundingInvestors';
import FundingModal from './FundingModal';

import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';


import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import AddIcon from '@mui/icons-material/Add';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import EditIcon from '@mui/icons-material/Edit';
import AutoDeleteIcon from '@mui/icons-material/AutoDelete';

function ProfileEditorViewer(props)  {
    const [fundingModalOpen, setFundingModalOpen] = useState(false);
    const [fundingRoundToEdit, setFundingRoundToEdit] = useState(null);
    const [mouseOverFundingId, setMouseOverFundingId] = useState(null);
    
    if (!props.profile) {
        return (
            <div/>
        )
    }

    const onEditFundingClicked = (funding) => {
        setFundingRoundToEdit(funding);
        setFundingModalOpen(true);
    }

    const getFormattedAmount = (amount) => {
        if (amount === 0) {
            return "";
        }
        return "$" + Math.round(amount * 100) / 100 + "M";
    }

    const getTaxonomyString = () => {
        if (props.investorMode) {
            if (props.profile.taxonomy.investorCategory) {
                return props.profile.taxonomy.investorCategory.name
            } else {
                return ""
            }
        } else {
            let taxString = props.profile.taxonomy.sector.name;
            if (props.profile.taxonomy.industry) {
                taxString += ", " + props.profile.taxonomy.industry.name;
            }
            if (props.profile.taxonomy.subIndustry) {
                taxString += ", " + props.profile.taxonomy.subIndustry.name;
            }
            return taxString;
        }
    }

    const getCityStateCountry = (profile) => {
        let addrStr = "";

        if (props.profile.addresses.length === 0) {return addrStr}

        if (props.profile.addresses[0].cityInfo) {
            addrStr += props.profile.addresses[0].cityInfo.name + ", ";
        }
        if (props.profile.addresses[0].stateInfo) {
            addrStr += props.profile.addresses[0].stateInfo.name + ", ";
        }
        if (props.profile.addresses[0].countryInfo) {
            addrStr += props.profile.addresses[0].countryInfo.name;
        }
        return addrStr;
    }

    const getAddress = (profile) => {
        let addrStr = "";

        if (props.profile.addresses.length === 0) {return addrStr}

        if (props.profile.addresses[0].street1) {
            addrStr += props.profile.addresses[0].street1 + ", ";
        }
        if (props.profile.addresses[0].street2) {
            addrStr += props.profile.addresses[0].street2 + ", ";
        }
        if (props.profile.addresses[0].cityInfo) {
            addrStr += props.profile.addresses[0].cityInfo.name + ", ";
        }
        if (props.profile.addresses[0].stateInfo) {
            addrStr += props.profile.addresses[0].stateInfo.name + ", ";
        }
        if (props.profile.addresses[0].countryInfo) {
            addrStr += props.profile.addresses[0].countryInfo.name;
        }
        return addrStr;

    }



    return (
        <div>
            <div style={{backgroundColor: "#000", marginBottom: "20px", height: "40px"}}>
                <img
                    alt=""
                    style={{marginTop: "4px", marginLeft: "12px"}}
                    height={32}
                    src="https://resources.cbinsights.com/cbi-site/50d755278b95c4602e8a38ca16186b28ede17211/537316/cbi-site-build/0a3eeef0c1015f8824ae.svg" />
            </div>
            <Grid container spacing={2}>
                <Grid size={10} offset={1}>
                    <Paper>
                        <Grid container spacing={2}>
                            {props.profile.logo && <Grid size={1}>
                                <div
                                    style={{height: "96px", display: "flex", justifyContent: "center", alignItems: "center"}}
                                >
                                    <img
                                        alt=""

                                        width={64}
                                        src={props.profile.logo}
                                    />
                                </div>
                            </Grid>}
                            {!props.profile.logo && <div style={{width: "12px"}}/>}
                            <Grid size={8}>
                                {!props.editMode &&  <Typography variant={'h4'}>{props.profile.entityNameInfo.primaryName}</Typography>}
                                {props.editMode &&
                                    <TextField
                                        sx={{marginTop: "10px"}}
                                        id="outlined-basic"
                                        label="Name"
                                        variant="outlined"
                                        value={props.profile.entityNameInfo.primaryName}
                                        onChange={(event)=> {props.updateEditedProfile("entityNameInfo.primaryName", event.target.value)}}
                                    />
                                }
                                <Typography
                                    sx={{color: "#777"}}
                                    variant={'subtitle1'}
                                >
                                    {getCityStateCountry(props.profile)}
                                </Typography>
                                <Typography
                                    sx={{color: "#777"}}
                                    variant={'subtitle1'}
                                >
                                    {getTaxonomyString()}
                                </Typography>
                            </Grid>
                            <Grid
                                container
                                direction="row"
                                size={2}
                                sx={{justifyContent: "flex-end", alignItems: "center"}}
                            >
                                {!props.editMode && <Button variant="contained"
                                        sx={{marginTop: "4px", display: "none"}}
                                        onClick={() => {
                                            props.setEditMode(true);
                                        }}
                                >
                                    Edit
                                </Button>}

                                {props.editMode &&
                                    <div>
                                        <Button variant="outlined"
                                            sx={{marginTop: "28px"}}
                                            onClick={() => {
                                                props.setEditMode(false);
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                        <Button variant="contained"
                                                sx={{marginTop: "28px", marginLeft: "4px"}}
                                                onClick={props.onSave}
                                        >
                                            Save
                                        </Button>
                                </div>}
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>

                <Grid size={10} offset={1}>
                    <Paper>
                        <Typography
                            variant={'h5'}
                            sx={{marginLeft: "24px", paddingTop: "12px"}}
                        >
                            About
                        </Typography>
                        <Typography
                            sx={{marginLeft: "24px", marginRight: "24px", marginTop: "12px"}}
                            variant={'subtitle1'}
                        >
                            {props.profile.description}
                        </Typography>


                        {props.profile.urlInfo && props.profile.urlInfo.primaryUrl &&
                            <div
                                style={{
                                    display: "flex",
                                    marginLeft: "24px",
                                    marginRight: "24px",
                                    marginTop: "24px",
                                    marginBottom: "12px"
                                }}
                            >
                                <svg role="img" width="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path fill="currentColor"
                                          d="M12 2s10 0 10 10-10 10-10 10S2 22 2 12 12 2 12 2Zm-1.8652 1.5968a11.2942 11.2942 0 0 1 1.1152-.1816v3.5749c-1.2465-.0245-2.2541-.0928-3.0656-.192.502-1.5678 1.2208-2.5663 1.9504-3.2013Zm-3.4329 2.939c.2776-.8728.618-1.5578.9847-2.0951-.7688.3838-1.5377.9043-2.2094 1.6104.2614.1749.6534.3414 1.2247.4847Zm-2.2155.8343c.3931.2348.9789.4638 1.8446.6536-.1738.9159-.2884 1.9829-.3213 3.2262H3.3862c.098-1.5936.5081-2.8652 1.1002-3.8798Zm3.3284.9004c.9254.1142 2.0557.1931 3.4352.2196V11.25H7.5107c.033-1.1332.1406-2.12.3041-2.9794Zm4.9352.2277V11.25h3.7403c-.0294-1.1082-.1236-2.0763-.2669-2.9222-.9332.0977-2.0761.1596-3.4734.1705Zm4.9362-.3816c.1641.8949.2723 1.9318.3041 3.1333h2.6235c-.0943-1.5332-.4775-2.7683-1.0337-3.7633-.3863.2326-.9847.454-1.8939.63Zm.9787-1.9117c-.2916.1623-.7206.3128-1.3336.4381-.2837-.9244-.637-1.6435-1.0187-2.2027.8238.4112 1.6479.9794 2.3523 1.7646Zm-2.7718.6468c-.8365.0838-1.8705.1365-3.1431.1465v-3.583a11.32 11.32 0 0 1 1.4267.2528c.6458.6451 1.2758 1.6428 1.7164 3.1837ZM6.0097 12.75H3.3862c.0926 1.506.464 2.7244 1.0042 3.7101.3941-.2267 1.0013-.4399 1.9178-.6075-.161-.8879-.267-1.9148-.2985-3.1026Zm.653 4.5874c-.6417.1316-1.0606.2929-1.3186.4676.7024.78 1.523 1.3451 2.3433 1.7546-.3844-.5631-.74-1.2884-1.0247-2.2222Zm3.1606 2.9945c-.648-.6472-1.2799-1.6493-1.7207-3.1988.83-.0791 1.8648-.1271 3.1474-.1326v3.5843a11.3423 11.3423 0 0 1-1.4267-.2529Zm2.9267.2529v-3.5706c1.247.0296 2.2518.1042 3.0586.2098-.5017 1.5551-1.2172 2.5471-1.9434 3.1792a11.324 11.324 0 0 1-1.1152.1816Zm0-5.0708c1.386.0322 2.5137.1183 3.4304.2402.1662-.8652.2757-1.8601.3089-3.0042H12.75v2.764Zm3.5634 4.0452c.3613-.5295.6971-1.2023.9725-2.0569.5559.1483.936.3189 1.1888.4965-.6601.6807-1.4108 1.1857-2.1613 1.5604Zm1.3474-3.5398c.8696.2063 1.4349.4535 1.7984.7021.6213-1.0294 1.0536-2.3295 1.1546-3.9715h-2.6235c-.0334 1.2629-.1511 2.344-.3295 3.2694Zm-9.8873-.3656c.9363-.0914 2.0806-.1473 3.4765-.1533V12.75H7.5097c.0291 1.1001.1223 2.0623.2638 2.9038Z"
                                          clip-rule="evenodd" fill-rule="evenodd"></path>
                                </svg>
                                <Typography
                                    sx={{marginLeft: "12px"}}
                                    variant={'subtitle2'}
                                >
                                    Website
                                </Typography>
                                <Typography
                                    sx={{color: "rgb(0, 102, 153)", marginLeft: "96px", cursor: "pointer"}}
                                    variant={'subtitle2'}
                                    onClick={() => {
                                        window.open("//" + props.profile.urlInfo.primaryUrl, "_blank");
                                    }}
                                >
                                    {props.profile.urlInfo.primaryUrl}
                                </Typography>

                            </div>
                        }

                        <div
                            style={{display: "flex", marginLeft: "24px", marginRight: "24px", marginTop: "12px"}}
                        >
                            <svg role="img" width="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M2 10V6.875c0-.5556.1958-1.007.5875-1.3542C2.9793 5.1736 3.4503 5 4.0003 5h16.0026c.5501 0 1.0205.1736 1.4112.5208.3906.3473.5859.7986.5859 1.3542V10h-1.875V6.875H3.875V10H2Zm1.9971 10c-.5501 0-1.0205-.1736-1.4112-.5208C2.1953 19.1319 2 18.6806 2 18.125V15h1.875v3.125h16.25V15H22v3.125c0 .5556-.1958 1.0069-.5875 1.3542-.3918.3472-.8628.5208-1.4128.5208H3.9971Zm6.1279-3.125c.1663 0 .3251-.0434.4763-.1302.1512-.0868.2661-.2095.3448-.368l2.9289-5.3612 1.0417 1.9271c.0694.1736.1779.2995.3255.3776s.3168.1172.5078.1172H22v-1.875h-5.6771l-1.6146-2.9427c-.0868-.1736-.2058-.2995-.357-.3776a1.024 1.024 0 0 0-.4763-.1172 1.024 1.024 0 0 0-.4763.1172c-.1512.0781-.2702.204-.357.3776l-2.9167 5.3646-1.0523-1.9214c-.0797-.16-.1952-.2835-.3464-.3703-.1512-.0868-.31-.1302-.4763-.1302H2v1.875h5.677l1.627 2.9424a.8538.8538 0 0 0 .3447.3649c.1512.0868.31.1302.4763.1302Z"></path></svg>
                            <Typography
                                sx={{marginLeft: "12px", marginTop: "16px"}}
                                variant={'subtitle2'}
                            >
                                Status
                            </Typography>
                            <p
                                style={{marginLeft: "103px"}}
                            >
                                {props.profile.status.status}
                            </p>
                        </div>

                        {props.profile.foundedYear !== 0 &&
                            <div
                                style={{display: "flex", marginLeft: "24px", marginRight: "24px", marginTop: "2px"}}
                            >
                                <svg role="img" width="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                    <path fill="currentColor"
                                          d="M4 21V3h9.3333L14 5.5714h6v10.2857h-6.6667l-.6666-2.5714H6V21H4Zm10.8889-7.0714H18V7.5h-5.5556l-.6666-2.5714H6v6.4285h8.2222l.6667 2.5715Z"></path>
                                </svg>
                                <Typography
                                    sx={{marginLeft: "12px", marginTop: "16px"}}
                                    variant={'subtitle2'}
                                >
                                    Founded Year
                                </Typography>
                                <p
                                    style={{marginLeft: "57px"}}
                                >
                                    {props.profile.foundedYear}
                                </p>
                            </div>
                        }

                        <div
                            style={{display: "flex", marginLeft: "24px", marginRight: "24px", marginTop: "2px"}}
                        >
                            <svg role="img" width="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M12.0054 12c.5092 0 .9433-.1841 1.3023-.5523.359-.3683.5385-.811.5385-1.3282s-.1813-.958-.5439-1.3226c-.3626-.3646-.7985-.5469-1.3077-.5469-.5092 0-.9433.1841-1.3023.5523-.359.3683-.5385.811-.5385 1.3282s.1813.958.5439 1.3226c.3626.3646.7985.5469 1.3077.5469ZM12 19.526c2.0342-1.8576 3.5684-3.5677 4.6026-5.1302 1.0342-1.5625 1.5512-2.96 1.5512-4.1927 0-1.8229-.5854-3.3333-1.7564-4.5312C15.2265 4.4739 13.7607 3.875 12 3.875c-1.7607 0-3.2265.599-4.3974 1.7969C6.4316 6.8698 5.846 8.3802 5.846 10.203c0 1.2327.5171 2.6302 1.5513 4.1927C8.4316 15.9583 9.9658 17.6684 12 19.526ZM12 22c-2.6832-2.2762-4.6874-4.3904-6.0126-6.3424C4.6624 13.7053 4 11.8872 4 10.2031c0-2.3264.7607-4.2751 2.282-5.8463C7.8034 2.7856 9.7051 2 11.9872 2c2.282 0 4.188.7856 5.7179 2.3568C19.235 5.928 20 7.8768 20 10.203c0 1.6841-.6581 3.4983-1.9744 5.4427C16.7094 17.5903 14.7009 19.7083 12 22Z"></path></svg>
                            <Typography
                                sx={{marginLeft: "12px", marginTop: "16px"}}
                                variant={'subtitle2'}
                            >
                                Headquarters
                            </Typography>
                            <p
                                style={{marginLeft: "57px"}}
                            >
                                {getAddress(props.profile)}
                            </p>
                        </div>

                        {props.profile.tagGroups.length > 0 &&
                            <div
                                style={{display: "flex", flexDirection: "row",marginLeft: "24px", marginRight: "24px", marginTop: "2px", marginBottom: "12px"}}
                            >
                                <svg role="img" width="24px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="currentColor" d="M8 3c-.552 0-1 .448-1 1v2H4c-1.093 0-2 .907-2 2v11c0 1.0931.907 2 2 2h16c1.0931 0 2-.9069 2-2V8c0-1.093-.9069-2-2-2h-3V4c0-.552-.448-1-1-1H8Zm1 2h6v1H9V5ZM4 8h16v11H4V8Z" clip-rule="evenodd" fill-rule="evenodd"></path></svg>
                                <Typography
                                    sx={{marginLeft: "12px", marginTop: "8px", marginRight: "36px"}}
                                    variant={'subtitle2'}
                                >
                                    Business Model
                                </Typography>
                                {props.profile.tagGroups[0].tags.map((tag) => (
                                    <Chip sx={{marginLeft: "2px"}} label={tag.tag} />
                                ))}

                            </div>
                        }

                        <div style={{height: "12px"}}/>
                    </Paper>
                </Grid>

                {!props.fundingsFetched &&
                    <Grid size={6} offset={3}>
                        <Typography
                            sx={{marginTop: "8px",textAlign: "center"}}
                            variant={'subtitle2'}
                        >
                            Loading {props.investorMode ? "investments" : "fundings"}...
                        </Typography>
                    </Grid>
                }

                {props.fundingsFetched && props.fundingsFetchError &&
                    <Grid size={6} offset={3}>
                        <Typography
                            sx={{marginTop: "8px",textAlign: "center"}}
                            variant={'subtitle2'}
                        >
                            Error fetching fundings.
                        </Typography>
                    </Grid>
                }

                {props.fundingsFetched && !props.fundingsFetchError &&
                    <Grid size={10} offset={1}>
                        <Paper sx={{marginBottom: "16px"}}>
                            <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between"}}>
                                <Typography
                                    variant={'h5'}
                                    sx={{marginLeft: "24px", marginTop: "12px"}}
                                >
                                    Deals
                                </Typography>
                                <Button
                                    onClick={() => {
                                        onEditFundingClicked(null)
                                    }}
                                >
                                    <AddIcon/>
                                </Button>
                            </div>
                            <TableContainer component={Paper}>
                                <Table sx={{minWidth: 650}} size="small" aria-label="a dense table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell align="right"/>
                                            {props.investorMode && <TableCell align="right">Company</TableCell>}
                                            <TableCell align="right">Date</TableCell>
                                            <TableCell align="right">Round</TableCell>
                                            <TableCell align="right">Amount</TableCell>
                                            <TableCell align="right">Investors</TableCell>
                                            <TableCell align="right">Valuation</TableCell>
                                            <TableCell align="right">Sources</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody
                                        onMouseLeave={() => {
                                            setMouseOverFundingId(null);
                                        }}
                                    >
                                        {props.fundings && props.fundings.map((funding) => (
                                            <TableRow
                                                hover={true}
                                                onMouseOver={() => {
                                                    setMouseOverFundingId(funding.idFunding ? funding.idFunding : funding.idFundingDraft)
                                                }}
                                                key={funding.idRound}
                                                sx={{'&:last-child td, &:last-child th': {border: 0}}}
                                            >
                                                <TableCell
                                                    align="right"
                                                    sx={{minWidth: "48px"}}
                                                >
                                                    <div style={{
                                                        display: "flex",
                                                        flexDirection: "row",
                                                        justifyContent: "left",
                                                    }}>
                                                        {funding.idFundingDraft === "" || funding.pendingDeletion ?
                                                            <div/> : <Tooltip title="Pending Review"><PendingActionsIcon
                                                                sx={{fontSize: 18}}/></Tooltip>}
                                                        {!funding.pendingDeletion ? <div/> :
                                                            <Tooltip title="Pending Deletion"><AutoDeleteIcon
                                                                sx={{fontSize: 18}}/></Tooltip>}
                                                        {!funding.pendingDeletion && <Button
                                                            sx={{
                                                                minWidth: '24px',
                                                                padding: "0px",
                                                                display: funding.idFunding === mouseOverFundingId || funding.idFundingDraft === mouseOverFundingId ? "block" : "none"
                                                            }}
                                                            onClick={() => {
                                                                onEditFundingClicked(funding)
                                                            }}
                                                        >
                                                            <EditIcon sx={{fontSize: 16}}/>
                                                        </Button>}
                                                    </div>
                                                </TableCell>
                                                {props.investorMode &&
                                                    <TableCell align="right">
                                                        <Typography
                                                            sx={{color: "rgb(0, 102, 153)", cursor: "pointer"}}
                                                            variant={'subtitle2'}
                                                            onClick={() => {
                                                                window.open("//" + funding.url, "_blank");
                                                            }}
                                                        >
                                                            {funding.entityName ? funding.entityName : funding.url}
                                                        </Typography>
                                                    </TableCell>
                                                }
                                                <TableCell
                                                    sx={{cursor: "pointer"}}
                                                    onClick={() => {
                                                        onEditFundingClicked(funding)
                                                    }}
                                                    align="right">
                                                    {funding.fundingDate}
                                                </TableCell>
                                                <TableCell
                                                    align="right"
                                                    sx={{cursor: "pointer"}}
                                                    onClick={() => {
                                                        onEditFundingClicked(funding)
                                                    }}
                                                >
                                                    {funding.fundingRound.name}
                                                </TableCell>
                                                <TableCell
                                                    sx={{cursor: "pointer"}}
                                                    onClick={() => {
                                                        onEditFundingClicked(funding)
                                                    }}
                                                    align="right"
                                                >
                                                    {getFormattedAmount(funding.amount)}
                                                </TableCell>
                                                <TableCell align="right">
                                                    <FundingInvestors investors={funding.investors}/>
                                                </TableCell>
                                                <TableCell
                                                    sx={{cursor: "pointer"}}
                                                    onClick={() => {
                                                        onEditFundingClicked(funding)
                                                    }}
                                                    align="right"
                                                >
                                                    {getFormattedAmount(funding.maxValuation)}
                                                </TableCell>
                                                <TableCell align="right">
                                                    <FundingNewsMentions mentions={funding.mentions}/>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            {props.fundings.length === 0 &&
                                    <div style={{
                                        width: "100%",
                                        marginTop: "18px",
                                        marginBottom: "12px",
                                        display: "flex",
                                        flexDirection: "row",
                                        justifyContent: "center",
                                    }}>
                                        <Typography
                                            sx={{color: "rgb(125, 125, 125)"}}
                                            variant={'subtitle2'}
                                        >
                                            No deals found, please add some to your profile.
                                        </Typography>
                                    </div>
                            }
                        </Paper>
                    </Grid>
                }
            </Grid>

            <FundingModal
                orgId={props.orgId}
                open={fundingModalOpen}
                handleClose={()=>{setFundingModalOpen(false)}}
                onFundingsUpdated={props.onFundingsUpdated}
                fundingRoundToEdit={fundingRoundToEdit}
                investorMode={props.investorMode}
                profile={props.profile}
                setAlertMessage={props.setAlertMessage}
            />
        </div>
    )
}

export default ProfileEditorViewer;

